import { inject, Injectable } from '@angular/core';
import { FlyoutStatusTracker } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  HeaderFooterMachCore,
  HeaderFooterMachCoreContentService,
  StatusTrackerFacadeService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { FlyoutStatusTrackerAdapterService } from '../../adapters/status-tracker/flyout-status-tracker-adapter.service';
import { LoadingLabel } from '../../models/constants/status-tracker/status.tracker.constants';
import { StatusTracker } from '../../models/interfaces/status-tracker/status-tracker.interfaces';

@Injectable({
  providedIn: 'root'
})
export class FlyoutStatusTrackerFacadeService {
  adapter = inject(FlyoutStatusTrackerAdapterService);
  statusTrackerFacade = inject(StatusTrackerFacadeService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  unsubscribe$: Subject<void> = new Subject();
  trackerFacadeData$ = new BehaviorSubject<FlyoutStatusTracker>(
    {} as FlyoutStatusTracker
  );

  aemContent = {} as HeaderFooterMachCore;

  init(): void {
    this.statusTrackerFacade.init();
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(
        tap((aemContent: HeaderFooterMachCore) => {
          this.aemContent = aemContent;
        }),
        map(() =>
          this.statusTrackerFacade.tracker$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res) => {
              if (!res.loaded) {
                this.trackerFacadeData$.next({
                  details: {} as StatusTracker,
                  loadingLabel: LoadingLabel
                });
              }
              if (res.error) {
                this.trackerFacadeData$.next(
                  this.adapter.getErrorContent(res, this.aemContent)
                );
              } else if (res.earnometer) {
                this.trackerFacadeData$.next(
                  this.adapter.getContent(res, this.aemContent)
                );
              }
            })
        )
      )
      .subscribe();
  }
}
